import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SettingsCtx = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  useEffect(() => { api.get("/settings").then(r => setSettings(r.data)).catch(() => setSettings({})); }, []);
  return <SettingsCtx.Provider value={settings}>{children}</SettingsCtx.Provider>;
}
export const useSettings = () => useContext(SettingsCtx) || {};
